import React from 'react';
import { Fragment, useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next/hooks';

// import Button from '../../Button/Button';
import EditGroupModal from '../EditGroup/EditGroupModal';
import GroupInvitationForm from './GroupInvitationForm';
import GroupInvitationList from './GroupInvitationList';
import GroupInviteAcceptUsers from './GroupInviteAcceptUsers';
import Loader from '../../Loader/Loader';

import { useStore } from '../../../hook-store/store';
import { 
  getGroupInvitationData, 
  // addGroupInvitation, 
  // cancelGroupInvitation,
} from '../../../util/group/group-invitation';
// import { email } from '../../../util/validators';

import { SOCKET_GROUP_URL } from '../../../App';

import '../../../pages/GroupTalk/GroupTalk.css';
import './GroupInvitation.css';

const GroupInvitation = (props) => {
  // console.log('grouplistItem.js props', props);

  const { 
    group,
    usersData,
    userId,
    isLoading,

    showInvitationModal,
    showInvitationModalHandler,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { groupInvitationData } = store.groupStore;

  const [isDataLoading, setIsDataLoading] = useState(false);

  useEffect(() => {
    if (showInvitationModal && group?.groupRoomId && 
          group.creatorUserId === userId
  ) {
      getGroupInvitationDataHandler(group.groupRoomId);
    }
  },[group, showInvitationModal]);



  const getGroupInvitationDataHandler = async (groupRoomId) => {
    try {
      setIsDataLoading(true);
      dispatch('SET_GROUPINVITATIONDATA', null);


      const resData = await getGroupInvitationData(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        groupRoomId,
      );

      if (resData.data) {
        dispatch('SET_GROUPINVITATIONDATA', resData.data);
      }

      setIsDataLoading(false);
    } catch(err) {
      console.log(err);

      setIsDataLoading(false);

      throw err;
    }
  };


  const groupInvitationModalBody = (
    <div>
      <div className='groupInvitationGroupName'>
        <span>
          {group.groupName}
        </span>
      </div>

      {isDataLoading && (
        <Loader />
      )}

      {/* {JSON.stringify(group)} */}

      {!(isDataLoading && groupInvitationData) && (
        <div>
          <GroupInvitationForm 
            showInvitationModal={showInvitationModal}
            showInvitationModalHandler={showInvitationModalHandler}
            isLoading={isLoading}
            group={group}
            userId={userId}
          />
          
          <GroupInvitationList
            showInvitationModal={showInvitationModal}
            showInvitationModalHandler={showInvitationModalHandler}
            isLoading={isLoading}
            group={group}
            userId={userId}
          />

          <GroupInviteAcceptUsers
            // showInvitationModal={showInvitationModal}
            // showInvitationModalHandler={showInvitationModalHandler}
            isLoading={isLoading}
            group={group}
            userId={userId}
          />
        </div>
      )}
    </div>
  );

  return (
      <Fragment>
        {showInvitationModal && 
          <EditGroupModal
            showConfirmModalHandler={showInvitationModalHandler}
            confirmModalContent={groupInvitationModalBody}
          />
        }

        </Fragment>
  );
}

export default GroupInvitation;